




































import { Vue, Component, Watch } from 'vue-property-decorator';
import Container from '../../components/Container.vue';
import ProfileDetail from './ProfileDetail.vue';
import ProfileDetailsByAdmin from './ProfileDetailsByAdmin.vue';
import PasswordManagement from './PasswordManagement.vue';
import { isDifferent } from '../../jbi-shared/util/watcher.vue-decorator';
import { Action } from 'vuex-class';
import { User } from '@/store/modules/admin/types/admin.types';
import { navUtil } from '@/utils/nav.util';

/**
 * Declaration of available tabs in the page
 */
const tabNames = ['profile', 'password'];

@Component({
  components: {
    ProfileDetail,
    PasswordManagement,
    ProfileDetailsByAdmin,
    Container
  }
})
export default class UserProfile extends Vue {
  @Action('userAttribute/updateAttributeValueValidity')
  updateAttributeValueValidity!: (isMissingAttributeValue: boolean) => void;

  isAdminUser = false;
  user: Partial<User> | null = null;
  private currentTab = 0;

  get currentRoute() {
    return this.$route.query;
  }

  get userDetails() {
    return this.user;
  }
  public mounted() {
    this.initializeProfileContext();
    this.onActiveTabChange(this.currentTab);
  }

  private initializeProfileContext(): void {
    this.isAdminUser = false;
    this.user = null;

    const routeQuery = this.$route.query || {};
    const isAdminFromQuery = routeQuery.isAdminUser === 'true';
    const userIdFromQuery = Number(routeQuery.userId);
    const hasValidUserIdFromQuery =
      Number.isFinite(userIdFromQuery) && userIdFromQuery > 0;

    if (isAdminFromQuery && hasValidUserIdFromQuery) {
      this.user = {
        userId: userIdFromQuery
      };
      this.isAdminUser = true;
    }
  }

  @Watch('currentRoute', { immediate: true, deep: true })
  private onTabChange(query: any) {
    this.initializeProfileContext();

    /**
     * Iterate through available tab indexes to find matching values
     */
    const tabIndex = Object.values(tabNames).findIndex(
      (value) => value === query.tab
    );

    this.currentTab = tabIndex !== -1 ? tabIndex : 0;
  }

  @Watch('currentTab')
  @isDifferent
  private onActiveTabChange(value: number): void {
    const isMissingAttributeValue: boolean =
      this.$route.query.missingAttributeValue === 'true';
    if (isMissingAttributeValue) {
      this.updateAttributeValueValidity(isMissingAttributeValue);
    }
    navUtil.ignoreDuplicateNavigation(
      this.$router.replace({
        query: { ...this.$route.query, tab: tabNames[value] }
      })
    );
  }
}
